import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'pending_pvs.manager.title',
  },
  displayAllClaimsButton: {
    id: 'home_page.display_all_claims',
  },
  noPendingFilesMessage: {
    id: 'no_pending_pv.message',
  },
  noPendingFilesTitle: {
    id: 'no_pending_pv.title',
  },
  openPvTitle: {
    id: 'opening_gestionnaire.open_pv_title',
  },
});
